// import "./App.css";
// import { Routes, Route } from "react-router-dom";
// import Home from "./Components/Home/Home";
// import Footer from "./Components/Footer/Footer";
// import AboutUs from "./Components/AboutUs/AboutUs";
// import OurTeam from "./Components/OurTeam/OurTeam";
// import ContactUs from "./Components/Contact Us/ContactUs";
// import Career from "./Components/Career/Career";
// import Payment from "./Components/Payment/Payment";
// import WebSolutionServices from "./Components/Services/WebSolutionServices";
// import ContentManagementSystem from "./Components/Services/ContentManagementSystem";
// import CRMSCMAndERPServices from "./Components/Services/CRMSCMAndERPServices";
// import EAIServices from "./Components/Services/EAIServices";
// import ECommerce from "./Components/Services/ECommerce";
// import MobileApplication from "./Components/Services/MobileApplication";
// import TechnicalMaintenance from "./Components/Services/TechnicalMaintenance";
// import SEOServices from "./Components/Services/SEOServices";
// import ApplicationMigration from "./Components/Services/ApplicationMigration";
// import BulkSMS from "./Components/Products/BulkSMS";
// import InteractiveVoiceResponse from "./Components/Products/InteractiveVoiceResponse";
// import LeadsManagementSystem from "./Components/Products/LeadsManagementSystem";
// import VirtualPhoneNumber from "./Components/Products/VirtualPhoneNumber";
// import MissedCallAlert from "./Components/Products/MissedCallAlert";
// import CustomerRelationship from "./Components/Products/CustomerRelationship";
// import EmployeeTrackingSystem from "./Components/Products/EmployeeTrackingSystem";
// import TermsCondition from "./Components/Terms&Condition";
// import Feature from "./Components/Feature/Feature";
// import PrivacyPolicy from "./Components/PrivacyPolicy";
// import RefundPolicy from "./Components/RefundPolicy";
// import SubNav from "./Components/Header/SubNav";
// import ScrollTop from "./Components/Website/ScrollTop";
// import ScrollToTopHead from "./Components/Website/ScrollToTopHead";
// import Navbar from "./Components/Header/Navbar";
// import CallToAction from "./Components/Website/CallToAction";
// import NotFound from "./Components/NotFound";
// import WhatApp from "./Components/Website/WhatApp";
// import Dashboard from "./Components/Admin/Dashboard";
// import Sidebar from "./Components/SideBar/Sidebar";
// import PrivateRoute from "./Components/Admin/routes/PrivateRoute";
// import Login from "./Components/Admin/Login";
// import { AuthProvider } from "./Components/Admin/context/AuthContext";

// function App() {
//   return (
//     <div>
//       <ScrollToTopHead />
//       <SubNav />
//       <div className=" top-0 sticky z-[999]">
//         <Navbar />
//       </div>

//       <div>
//         <AuthProvider>
//           <Routes>
//             <Route path="/" element={<Home />} />
//             <Route path="/about-us" element={<AboutUs />} />

//             <Route path="/feature" element={<Feature />} />
//             <Route path="/our-team" element={<OurTeam />} />
//             <Route
//               path="/services/web-solution-services"
//               element={<WebSolutionServices />}
//             />
//             <Route
//               path="/services/content-management-system"
//               element={<ContentManagementSystem />}
//             />
//             <Route
//               path="/services/crm-scm-and-erp-services"
//               element={<CRMSCMAndERPServices />}
//             />
//             <Route path="/services/eai-services" element={<EAIServices />} />
//             <Route path="/services/e-commerce" element={<ECommerce />} />
//             <Route
//               path="/services/mobile-application"
//               element={<MobileApplication />}
//             />
//             <Route
//               path="/services/technical-maintenance"
//               element={<TechnicalMaintenance />}
//             />
//             <Route
//               path="/services/application-migration"
//               element={<ApplicationMigration />}
//             />
//             <Route path="/services/seo-services" element={<SEOServices />} />
//             {/* bulk product route*/}
//             <Route path="/products/bulk-sms" element={<BulkSMS />} />
//             <Route
//               path="/products/interactive-voice-response"
//               element={<InteractiveVoiceResponse />}
//             />

//             <Route
//               path="/products/leads-management-system"
//               element={<LeadsManagementSystem />}
//             />
//             <Route
//               path="/products/virtual-phone-number"
//               element={<VirtualPhoneNumber />}
//             />
//             <Route
//               path="/products/missed-call-alert-services"
//               element={<MissedCallAlert />}
//             />
//             <Route
//               path="/products/customer-relationship"
//               element={<CustomerRelationship />}
//             />
//             <Route
//               path="/products/employee-tracking-system"
//               element={<EmployeeTrackingSystem />}
//             />
//             <Route path="/terms-and-conditions" element={<TermsCondition />} />
//             <Route path="/privacy-policy" element={<PrivacyPolicy />} />
//             <Route path="/refund-policy" element={<RefundPolicy />} />
//             <Route path="/contact-us" element={<ContactUs />} />
//             <Route path="/career" element={<Career />} />
//             <Route path="/payment" element={<Payment />} />
//             <Route path="*" element={<NotFound />} />
//           {/* admin pannel routing is here */}

//           <Route path="/admin" element={<Login />} />
//           <Route
//             path="/admin/dashboard"
//             element={
//               <PrivateRoute>
//                 <div className="flex">
//                   <Sidebar />
//                   <Dashboard />
//                 </div>
//               </PrivateRoute>
//             }
//           />
//           </Routes>
//         </AuthProvider>
//       </div>
//       <WhatApp />
//       <ScrollTop />
//       <CallToAction />
//       <Footer />
//     </div>
//   );
// }

// export default App;

// App.js - Updated (remove the duplicate admin route)
import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";

// Public Components
import Home from "./Components/Home/Home";
import Footer from "./Components/Footer/Footer";
import AboutUs from "./Components/AboutUs/AboutUs";
import ContactUs from "./Components/Contact Us/ContactUs";
import Career from "./Components/Career/Career";
import Payment from "./Components/Payment/Payment";
import WebSolutionServices from "./Components/Services/WebSolutionServices";
import ContentManagementSystem from "./Components/Services/ContentManagementSystem";
import CRMSCMAndERPServices from "./Components/Services/CRMSCMAndERPServices";
import EAIServices from "./Components/Services/EAIServices";
import ECommerce from "./Components/Services/ECommerce";
import MobileApplication from "./Components/Services/MobileApplication";
import TechnicalMaintenance from "./Components/Services/TechnicalMaintenance";
import SEOServices from "./Components/Services/SEOServices";
import ApplicationMigration from "./Components/Services/ApplicationMigration";
import BulkSMS from "./Components/Products/BulkSMS";
import InteractiveVoiceResponse from "./Components/Products/InteractiveVoiceResponse";
import LeadsManagementSystem from "./Components/Products/LeadsManagementSystem";
import VirtualPhoneNumber from "./Components/Products/VirtualPhoneNumber";
import MissedCallAlert from "./Components/Products/MissedCallAlert";
import CustomerRelationship from "./Components/Products/CustomerRelationship";
import EmployeeTrackingSystem from "./Components/Products/EmployeeTrackingSystem";
import TermsCondition from "./Components/Terms&Condition";
import Feature from "./Components/Feature/Feature";
import PrivacyPolicy from "./Components/PrivacyPolicy";
import RefundPolicy from "./Components/RefundPolicy";
import SubNav from "./Components/Header/SubNav";
import ScrollTop from "./Components/Website/ScrollTop";
import ScrollToTopHead from "./Components/Website/ScrollToTopHead";
import Navbar from "./Components/Header/Navbar";
import CallToAction from "./Components/Website/CallToAction";
import NotFound from "./Components/NotFound";
import WhatApp from "./Components/Website/WhatApp";
import AdminRoutes from "./routes/AdminRoutes";
import { AuthProvider } from "./context/AuthContext";
import CaseDetail from "./Components/CaseStudy/CaseDetail";
import Blog from "./Components/Blog/Blog";
import BlogDetail from "./Components/Blog/BlogDetail";
import OurTeam from "./Components/OurTeam/OurTeam";
import { HelmetProvider } from "react-helmet-async";
import PaymentSuccess from "./Components/Payment/PaymentSuccess";
import PaymentFailure from "./Components/Payment/PaymentFailure";
import WhatsappPrivacyPolicy from "./Components/WhatsApp/WhatsappPrivacyPolicy";
import WhatsAppTerms from "./Components/WhatsApp/WhatsAppTerms";
import DeleteMetaProfile from "./Components/WhatsApp/DeleteMetaProfile";
import NewYear from "./Components/NewYear";
import GetData from "./Components/GetData";

function App() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");
  const noLayoutRoutes = ["/new-year"];
  const hideLayout = isAdminRoute || noLayoutRoutes.includes(location.pathname);

  return (
    <HelmetProvider>
      <AuthProvider>
        {/* Website Layout - only show if NOT in admin route */}
        {!hideLayout && (
          <>
            <ScrollToTopHead />
            <SubNav />
            <div className="top-0 sticky z-[999]">
              <Navbar />
            </div>
          </>
        )}

        <Routes>
          {/* Admin route - only once */}
          <Route path="/admin/*" element={<AdminRoutes />} />

          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/feature" element={<Feature />} />
          <Route path="/our-team" element={<OurTeam />} />
          <Route path="/blog" element={<Blog />} />
          
          {/* service routing */}
          <Route path="/web-solution" element={<WebSolutionServices />} />
          <Route path="/content-management-system" element={<ContentManagementSystem />} />
          <Route path="/crm-scm-and-erp-services" element={<CRMSCMAndERPServices />} />
          <Route path="/eai-services" element={<EAIServices />} />
          <Route path="/e-commerce-services" element={<ECommerce />} />
          <Route path="/mobile-application-services" element={<MobileApplication />} />
          <Route path="/technical-maintenance-services" element={<TechnicalMaintenance />} />
          <Route path="/application-migration" element={<ApplicationMigration />} />
          <Route path="/seo-services" element={<SEOServices />} />
          
          {/* product routing */}
          <Route path="/bulk-sms" element={<BulkSMS />} />
          <Route path="/interactive-voice-response" element={<InteractiveVoiceResponse />} />
          <Route path="/leads-management-system" element={<LeadsManagementSystem />} />
          <Route path="/virtual-phone-number" element={<VirtualPhoneNumber />} />
          <Route path="/missed-call-alert-services" element={<MissedCallAlert />} />
          <Route path="/customer-relationship" element={<CustomerRelationship />} />
          <Route path="/employee-tracking-system" element={<EmployeeTrackingSystem />} />
          <Route path="/terms-and-conditions" element={<TermsCondition />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/career" element={<Career />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="*" element={<NotFound />} />
          
          {/* payment system */}
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-failure" element={<PaymentFailure />} />

          {/* Dynamic Routing Data */}
          <Route path="/case-studies/:slug" element={<CaseDetail />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />

          {/* whatsApp features */}
          <Route path="/whatsapp/privacy-policy" element={<WhatsappPrivacyPolicy />} />
          <Route path="/whatsapp/terms-and-conditions" element={<WhatsAppTerms />} />
          <Route path="/remove-meta-business-profile" element={<DeleteMetaProfile />} />
          <Route path="/new-year" element={<NewYear />} />
          <Route path="/data-get" element={<GetData />} />
        </Routes>

        {/* Footer, WhatsApp & Others – only show on website, not admin */}
        {!hideLayout && (
          <>
            <WhatApp />
            <ScrollTop />
            <CallToAction />
            <Footer />
          </>
        )}
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;